import { getData, isAuth } from "actions";
import axios from "axios";
import {
  CardContainer,
  CompPagination,
  Container,
  ModalNotificationUpdate,
} from "components";
import {
  API_URL_notification,
  API_URL_notificationUpdate,
  baseurl,
} from "constants/api";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { FaTicketAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { notificationReducers } from "redux/notificationSlice";
import { notificationUpdateAllReducers } from "redux/notificationUpdateAllSlice";
import { notificationUpdateReducers } from "redux/notificationUpdateSlice";

const NotificationsUpdate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const datauser = isAuth();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [itemModal, setItemModal] = useState(false);
  const { getNotificationUpdateAllResult } = useSelector((state) => ({
    getNotificationUpdateAllResult:
      state.notificationUpdateAll.getNotificationUpdateAllResult,
  }));

  const getNotificationUpdate = useCallback(
    async (params) => {
      getData(
        API_URL_notificationUpdate,
        params,
        { dispatch, redux: notificationUpdateAllReducers },
        "GET_NOTIFICATIONUPDATEALL"
      );
    },
    [dispatch]
  );

  const handlePageClick = ({ selected }) => {
    const newOffset = selected * limit;
    const params = `?user_id=${datauser.user_id}&limit=${limit}&offset=${newOffset}`;
    setOffset(newOffset);
    setCurrentPage(selected);
    getNotificationUpdate(params);
  };

  const onRead = (item) => {
    setIsOpen(true);
    setItemModal(item);
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      url: baseurl + "/master/notificationupdate/read/" + item.id + "/",
    })
      .then((response) => {
        console.log(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const fetchData = useCallback(() => {
    const params = `?user_id=${datauser.user_id}`;
    getNotificationUpdate(params);
  }, [getNotificationUpdate]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container>
      <CardContainer title={"View All Update Notifications"}>
        <div className="m-5">
          {getNotificationUpdateAllResult.results &&
            getNotificationUpdateAllResult.results.map((item, index) => (
              <div
                key={index}
                onClick={() => onRead(item)}
                className="cursor-pointer bg-gray-200 dark:bg-neutral-600 shadow-lg rounded-lg overflow-hidden mb-2 flex items-center hover:bg-gray-300 "
              >
                <div className="p-4 w-full">
                  <div className="flex justify-between items-center">
                    <p className="text-xl font-bold">{item.title}</p>
                    <span>
                      {moment(item.created_at).format("DD MMMM YYYY, HH:mm:ss")}
                    </span>
                  </div>
                  <div
                    className="mt-2 mb-2 ck-editor-content"
                    dangerouslySetInnerHTML={{ __html: item.message }}
                  ></div>
                </div>
              </div>
            ))}
        </div>
        <div className="p-5 ">
          <CompPagination
            handlePageClick={(e) => handlePageClick(e)}
            pageCount={
              getNotificationUpdateAllResult.count > 0
                ? getNotificationUpdateAllResult.count
                : 0
            }
            limit={limit}
            offset={offset}
            currentPage={currentPage}
          />
        </div>
      </CardContainer>
      <ModalNotificationUpdate
        isOpen={isOpen}
        onClose={closeModal}
        item={itemModal}
      />
    </Container>
  );
};

export default NotificationsUpdate;
